import { ChangeDetectorRef, Component,ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { GraficasProvider } from '../../providers/graficas/graficas'
import { Chart } from 'chart.js';
import { ClientesProvider } from '../../providers/clientes/clientes'
import { AuthService } from '../../providers/auth-service'
import { CompaniasProvider } from '../../providers/companias/companias'
import * as papa from 'papaparse'
import { UsuariosProvider } from '../../providers/usuarios/usuarios'
import { Storage } from '@ionic/storage';
import { NUBE_AWS } from '../../config/url.servicio';
import { UtilsProvider } from '../../providers/utils/utils'
import { InformesProvider } from '../../providers/informes/informes';


// @IonicPage()
@Component({
  selector: 'page-inventario',
  templateUrl: 'inventario.html',
  providers: [ AuthService ]
})
export class inventarioPage {
  @ViewChild('barCanvas') barCanvas;
  @ViewChild('barCanvasafn') barCanvasafn;
  @ViewChild('doughnutCanvas') doughnutCanvas;
  @ViewChild('lineCanvas') lineCanvas;
  @ViewChild('doughnutCanvasUno') doughnutCanvasUno;
  @ViewChild('doughnutCanvasDos') doughnutCanvasDos;
  @ViewChild('doughnutCanvasTres') doughnutCanvasTres;

  barChart: any;
  doughnutChart: any;
  doughnutChartUno: any;
  doughnutChartDos: any;
  doughnutChartTres: any;
  lineChart: any;
  data = []
  datos = ""
  labels = ""
  dataReal = [{valorReal:-1}]
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  parsedData:any
  parsedDataReal:any
  parseDataHeader:any

  parsedDataSemanalesPorDia:any
  parsedDataRealSemanalesPorDia:any
  parseDataHeaderSemanalesPorDia:any

  parsedDataMensualesPorSemana:any
  parsedDataRealMensualesPorSemana:any
  parseDataHeaderMensualesPorSemana:any

  parsedDataAnualesPorMes:any
  parsedDataRealAnualesPorMes:any
  parseDataHeaderAnualesPorMes:any

  parsedDataproducto:any
  parsedDataRealproducto:any
  parseDataHeaderproducto:any
  companiasId : any = null
  productos: any[] = [];
  //editableFields: string[] = ['nombreProducto', 'cantidad'];  // Asegúrate de que esta propiedad esté definida
  editableFields = ['nombreCompleto', 'existenciasMinimas', 'existenciasActuales','valorVenta','costo']; // Campos editables
  // Para controlar qué campos son editables dinámicamente.
  productosHistorial: ProductoHistorial[] = [];
  productoSeleccionado: any | null = null; // Variable para el producto seleccionado
  isModalOpen = false;
  selectedProducto: any = null;  // Producto seleccionado para mostrar el historial
  paginaActual: number = 0;
  totalPaginas: number = 0;
  cargando: boolean = false;
  progreso: number = 0;
  barraVisible: boolean = false;
  barraVisibleActualizarProductos: boolean = false;
  clientes:any[]=[]
  clientesCopia:any[]=[]
  cantidadPorPagina: number = 100;
  public page: number = 0;
  public search: string = '';
  totalRegistros:number = 0
  controlaCambiosEnLosProductos: boolean = false
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicio:GraficasProvider,
              public utils:ClientesProvider,
              public auth: AuthService,
              public servicioCompania:CompaniasProvider,
              public serviciUsuario:UsuariosProvider,
              public alertCtrl:AlertController,
              public storage:Storage,
              public mensajero: UtilsProvider,
              public servicioDescargar: InformesProvider,
              private cd: ChangeDetectorRef) {


                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','usuariosId','companiasId'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    let codigo = val['usuariosId']
                    this.companiasId = val['companiasId']
                    this.serviciUsuario.buscarUsuarioAdministrador(codigo).subscribe((data)=>{
                      data = NUBE_AWS ? JSON.parse(data['_body']).data[0]: data
                      if(!data[0].administrador){
                        this.showAlert('No tiene permiso para ver los informes')
                        this.navCtrl.setRoot('HomePage');
                      }
                    },(error)=>{

                      this.navCtrl.setRoot('HomePage');
                    })
                  }
                })
  }

  showAlert(msj) {
    let alert = this.alertCtrl.create({
      title: 'Verifique..',
      subTitle: msj,
      buttons: ['OK']
    });
    alert.present();
  }

  ionViewDidLoad() {
     this.buscarProductos()
     let datosCreditos = localStorage.getItem('datosGenerales')
     let datosCredito = JSON.parse(datosCreditos)
     if(datosCredito && datosCredito["controlaCambiosEnLosProductos"]) {
       this.controlaCambiosEnLosProductos = datosCredito["controlaCambiosEnLosProductos"].seleccion === 'S' ? true : false
     }
  }


  async buscarProductos() {
    this.buscarProductosPorEmpresa();
  }

async tienenDiferencias(productosYaPrecargados: any[], companiasId: any) {
  let usuariosId = localStorage.getItem('usuariosId');

  // Obtener productos que aún no existen en cambiosEnLosProductos
  let dataProductosGuardados = await this.serviciUsuario.buscarProductosNuevosCambiosEnLosProductos(companiasId);
  let productosGuardados = dataProductosGuardados.json(); // Convertir a JSON

  // Obtener los últimos cambios registrados por cada productoId
  let dataUltimosCambios = await this.serviciUsuario.buscarUltimosCambiosProductos(companiasId);
  let ultimosCambios = dataUltimosCambios.json();

  // Verificar si hay productos nuevos que no existen en cambiosEnLosProductos
  if (productosGuardados && productosGuardados.data && productosGuardados.data[0].length > 0) {
    await Promise.all(productosGuardados.data[0].map(async (nuevoProducto) => {
      if (!nuevoProducto.productosId) return;

      await this.serviciUsuario.guardarCambiosEnLosProductos(
        companiasId,
        usuariosId,
        nuevoProducto.productosId,
        nuevoProducto.nombreCompleto,
        nuevoProducto.existenciasActuales,
        nuevoProducto.existenciasMinimas,
        nuevoProducto.valorVenta,
        nuevoProducto.costo == null ? 0 : nuevoProducto.costo,
        null // No hay cambios previos porque es un nuevo registro
      );
    }));
  }

  // Verificar si hay cambios en los productos ya precargados
  if (ultimosCambios && ultimosCambios.data && ultimosCambios.data[0].length > 0) {
    await Promise.all(ultimosCambios.data[0].map(async (productoAnterior) => {
      let productoPrecargado = productosYaPrecargados.find(p => p.productosId == productoAnterior.productosId);
      if (!productoPrecargado) return; // Si no existe en productosYaPrecargados, no se compara

      let cambiosDetectados: any = {};

      // Comparar campo por campo
      ['nombreCompleto', 'existenciasActuales', 'existenciasMinimas', 'valorVenta', 'costo'].forEach(campo => {
        if (productoAnterior[campo] !== productoPrecargado[campo]) {
          cambiosDetectados[campo] = {
            antes: productoAnterior[campo],
            ahora: productoPrecargado[campo]
          };
        }
      });

      // Si hay cambios, guardar un nuevo registro
      if (Object.keys(cambiosDetectados).length > 0) {
        await this.serviciUsuario.guardarCambiosEnLosProductos(
          companiasId,
          usuariosId,
          productoAnterior.productosId,
          productoPrecargado.nombreCompleto,
          productoPrecargado.existenciasActuales,
          productoPrecargado.existenciasMinimas,
          productoPrecargado.valorVenta,
          productoPrecargado.costo == null ? 0 : productoPrecargado.costo,
          JSON.stringify(cambiosDetectados)
        );
      }
    }));
  }

  console.log('Proceso finalizado: productos nuevos y cambios detectados fueron guardados.');
}

async openHistorialModal(producto) {
  if(!this.controlaCambiosEnLosProductos){
    this.mensajero.mensajeMuestroConCerrado('Debe activar el parámetro: Controla Cambios En Los Productos para poder entrar a esta opción', 'Info', 'warning',true);
    return;
  }
  this.isModalOpen = false;
  this.cd.detectChanges();
  let companiasId = localStorage.getItem('companiasId');

  try {
    let dataProductosGuardados = await this.serviciUsuario.buscarCambiosEnLosProductosPorId(companiasId, producto.productosId);
    let productosGuardados = JSON.parse(dataProductosGuardados['_body']);



    if (productosGuardados && productosGuardados.data && productosGuardados.data[0].length > 0) {
      let selectedProducto = productosGuardados.data[0].map((item) => {
        let cambiosParseados = null;

        try {


            if (item.cambios) {
              cambiosParseados = JSON.parse(item.cambios);
              if (typeof cambiosParseados !== 'object') {
                cambiosParseados = null;
              }
            }

        } catch (error) {
          console.error("Error al parsear 'cambios':", error, item.cambios);
        }

        return {
          ...item,
          cambios: cambiosParseados, // Ahora es un objeto JSON real
        };
      });
      let data = selectedProducto.reverse()
      this.selectedProducto = [...data];
      this.isModalOpen = true;  // Activa el modal
      this.cd.detectChanges();
    } else {
      console.log("No se encontró el producto guardado para comparar.");
      return;
    }
  } catch (error) {
    console.error("Error al obtener el historial de cambios:", error);
  }
}




// Ordena el historial por fecha (de más reciente a más antiguo)
getSortedHistorial() {
  return this.selectedProducto
    .map((item) => ({
      ...item,
      cambios: item.cambios ? JSON.parse(item.cambios) : null // Convierte JSON string a objeto
    }))
    .sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime()); // Orden descendente
}

getCamposModificados(historial: any): string[] {
  console.log("Historial recibido en getCamposModificados:", historial);

  if (!historial || !historial.cambios) {
    console.log("No hay cambios en este historial.");
    return [];
  }

  return Object.keys(historial.cambios);
}
// Cierra el modal
closeModal() {
  const modal = document.getElementById('historialModal');
  if (modal) {
    modal.style.display = 'none';  // Oculta el modal
  }
}


async validarCambios(productosGuardados: any[], productosActuales: any[]) {
  let cambiosARegistrar = [];

  productosActuales.forEach((producto) => {
    const productoGuardado = productosGuardados.find(p => p.productosId === producto.productosId);

    if (productoGuardado) {
      const cambios = this.compararCambios(producto, productoGuardado);

      if (Object.keys(cambios).length > 0) {
        const historial = {
          productosId: producto.productosId,
          nombreCompleto: producto.nombreCompleto,
          existenciasActuales: producto.existenciasActuales,
          existenciasMinimas: producto.existenciasMinimas,
          valorVenta: producto.valorVenta,
          costo: producto.costo,
          fecha: new Date().toISOString(),
          cambios: JSON.stringify(cambios),
        };

        cambiosARegistrar.push(historial);
      }
    }
  });
  let companiasId = await localStorage.getItem('companiasId')
  let usuariosId = await localStorage.getItem('usuariosId')
  if (cambiosARegistrar.length > 0) {


    // Enviamos todos los cambios en una sola petición
    await Promise.all(cambiosARegistrar.map(async (cambio) => {
      if(cambio.productosId == undefined) {
        return
      }
      await this.serviciUsuario.guardarCambiosEnLosProductos(
        companiasId,
        usuariosId,
        cambio.productosId,
        cambio.nombreCompleto,
        cambio.existenciasActuales,
        cambio.existenciasMinimas,
        cambio.valorVenta,
        cambio.costo,
        cambio.cambios
      );
    }));
  }
  this.productos = productosActuales;
}


compararCambios(productoActual: any, productoGuardado: any) {
  const cambios: any = {};

  if (productoActual.nombreCompleto !== productoGuardado.nombreCompleto) {
    cambios['nombreCompleto'] = {
      antes: productoGuardado.nombreCompleto,
      ahora: productoActual.nombreCompleto
    };
  }

  if (productoActual.valorVenta !== productoGuardado.valorVenta) {
    cambios['valorVenta'] = {
      antes: productoGuardado.valorVenta,
      ahora: productoActual.valorVenta
    };
  }

  if (productoActual.costo !== productoGuardado.costo) {
    cambios['costo'] = {
      antes: productoGuardado.costo,
      ahora: productoActual.costo
    };
  }

  if (productoActual.existenciasActuales !== productoGuardado.existenciasActuales) {
    cambios['existenciasActuales'] = {
      antes: productoGuardado.existenciasActuales,
      ahora: productoActual.existenciasActuales
    };
  }

  if (productoActual.existenciasMinimas !== productoGuardado.existenciasMinimas) {
    cambios['existenciasMinimas'] = {
      antes: productoGuardado.existenciasMinimas,
      ahora: productoActual.existenciasMinimas
    };
  }

  return cambios;
}

// Función para versionar los productos iniciales
async versionarProductosInicial(productos: any) {
  const productosVersionados = productos.map((producto) => ({
    ...producto,
    historial: [{
      nombreCompleto: producto.nombreCompleto,
      existenciasActuales: producto.existenciasActuales,
      existenciasMinimas: producto.existenciasMinimas,
      valorVenta: producto.valorVenta,
      costo: producto.costo,
      fecha: new Date().toISOString(),
      cambios: null, // No hay cambios iniciales
    }]
  }));
  let companiasId = await localStorage.getItem('companiasId')
  let usuariosId = await localStorage.getItem('usuariosId')

  if (productosVersionados.length > 0) {


    // Guardamos todos los productos en la BD en una sola llamada
    await Promise.all(productosVersionados.map(async (producto) => {
      if(producto.productosId == undefined) {
        this.totalRegistros = producto.totalRegistros || 0;
        return
      }
      await this.serviciUsuario.guardarCambiosEnLosProductos(
        companiasId,
        usuariosId,
        producto.productosId,
        producto.nombreCompleto,
        producto.existenciasActuales,
        producto.existenciasMinimas,
        producto.valorVenta,
        producto.costo == null ? 0 : producto.costo,
        producto.cambios
      );
    }));
  }
  this.productos = productos
}

verHistorial(producto: any) {
  this.productoSeleccionado = producto;
}

    // Hacer que los campos sean editables y mostrar el input
    toggleEditableFields(field: string) {
      if (this.editableFields.indexOf('nombreCompleto') !== -1) {
        const index = this.editableFields.indexOf(field);
        this.editableFields.splice(index, 1); // Eliminar si ya está en el array.
      } else {
        this.editableFields.push(field); // Agregar si no está en el array.
      }
    }



  trackByFn(index:any,item:any){
    return index;
  }

  descargarProducto(name:any){
    let csv = papa.unparse({
      fields: this.parseDataHeaderproducto,
      data: this.parsedDataRealproducto
    })

    var blob = new Blob([csv])
    var a = window.document.createElement("a")
    a.href = window.URL.createObjectURL(blob)
    a.download = name + '.csv'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  actualizarRegistro(producto) {
    this.actualizarProducto(producto)
  }

  async registrarHistorial(producto:any) {
    let companiasId = localStorage.getItem('companiasId');
    let dataProductosGuardados = await this.serviciUsuario.buscarProductosParaCambiosEnLosProductos(companiasId,producto.productosId)
    let productosGuardados = JSON.parse(dataProductosGuardados['_body']);
    let productoGuardado = undefined
    if (productosGuardados && productosGuardados.data && productosGuardados.data[0].length > 0) {
       productoGuardado = productosGuardados.data[0][0]
    } else {
      console.log("No se encontró el producto guardado para comparar.");
      return;
    }
    const cambios = this.compararCambios(producto, productoGuardado);

    if (Object.keys(cambios).length > 0) {
      const historial = {
        productosId: producto.productosId,
        nombreCompleto: producto.nombreCompleto,
        existenciasActuales: producto.existenciasActuales,
        existenciasMinimas: producto.existenciasMinimas,
        valorVenta: producto.valorVenta,
        costo: producto.costo,
        fecha: new Date().toISOString(),
        cambios: JSON.stringify(cambios),
      };

      // Enviar cambios al backend
      let companiasId = localStorage.getItem('companiasId');
      let usuariosId = localStorage.getItem('usuariosId');

      this.serviciUsuario.guardarCambiosEnLosProductos(
        companiasId,
        usuariosId,
        historial.productosId,
        historial.nombreCompleto,
        historial.existenciasActuales,
        historial.existenciasMinimas,
        historial.valorVenta,
        historial.costo,
        historial.cambios
      );

      // Actualizar la lista de productos con el producto modificado
      this.productos = this.productos.map(p =>
        p.productosId === producto.productosId ? producto : p
      );
    }

  }


  trackById(index, item) {
    return item.productosId; // Usa el ID del producto para mejorar rendimiento
  }

  descargarExcel() {
    if (this.selectedProducto && this.selectedProducto.length > 0) {
      // Preparamos los datos que queremos exportar
      const data = this.selectedProducto.map(historial => {
        // Aseguramos que 'historial.cambios' no sea null ni undefined
        const cambios = historial.cambios || {}; // Si no existe cambios, asignamos un objeto vacío

        // Verificamos si hay cambios
        if (Object.keys(cambios).length === 0) {
        }

        // En caso de que haya cambios, procesamos cada campo modificado
        const rows = [];
        Object.keys(cambios).forEach(key => {
          rows.push({
            'Campo Modificado': key,
            'Valor Antes': cambios[key] && cambios[key].antes ? cambios[key].antes : '',
            'Valor Después': cambios[key] && cambios[key].ahora ? cambios[key].ahora : '',
            'Fecha del Cambio': historial.fecha,
            'companiasId': historial.companiasId,
            'nombre': historial.nombreCompleto,
            'productosId': historial.productosId,
            'usuariosId': historial.usuariosId,
            'valorVenta': historial.valorVenta
          });
        });

        return rows; // Devolvemos múltiples filas para cada campo modificado
      });

      // Aplanamos el arreglo de filas y filtramos los datos vacíos antes de exportarlos
      const filteredData = data.flat().filter(function(item) {
        return Object.keys(item).length > 0;
      });

      if (filteredData.length > 0) {
        this.descargarData(filteredData,'productosversionados')
      } else {
        console.log('No hay cambios para exportar');
      }
    }
  }

  descargarData(data:any,nombre:any) {
    this.servicioDescargar.exportToExcel(data, nombre);
  }

  async buscarProductosPorEmpresa() {
    let companiasId = await localStorage.getItem('companiasId')
    this.barraVisible = true;
    this.utils.buscarProductosPorEmpresaPaginado(companiasId, this.paginaActual, this.cantidadPorPagina)
      .subscribe((respuesta: any) => {
        const totalRegistrosJson =   !NUBE_AWS ? respuesta : JSON.parse(respuesta['_body']).data[0];
        const totalRegistros = totalRegistrosJson[0].totalRegistros
        this.totalPaginas = totalRegistrosJson[0].totalPaginas;
        this.progreso = 0;
        this.clientes = []; // Limpia el array de clientes
        this.clientesCopia = []
        this.cargarProductosPaginados(totalRegistros);
      }, error => {
        console.log(error);
      });
  }

  // Función para cargar clientes de cada página y concatenarlos
  async cargarProductosPaginados(totalRegistros: number) {
    let companiasId = await localStorage.getItem('companiasId')

    if (this.paginaActual <= this.totalPaginas) {
      this.utils.buscarProductosPorEmpresaPaginado(companiasId, this.paginaActual, this.cantidadPorPagina)
        .subscribe((data: any) => {
          const clientesPagina = !NUBE_AWS ? data : JSON.parse(data['_body']).data;

          this.clientesCopia = [...this.clientesCopia, ...clientesPagina];

          const registrosCargados = this.clientesCopia.length;
          const totalRegistros = Number(this.totalPaginas) * Number(this.cantidadPorPagina); // Total de registros que se esperan

        const porcentaje = (registrosCargados / totalRegistros) * 100;
        this.progreso = Math.min(Math.max(porcentaje, 0.01), 100);
        this.progreso = Math.max(this.progreso, 0.01);

          setTimeout(() => {
            this.cd.detectChanges(); // Forzar la detección de cambios
          }, 0);

          // Incrementar la página y cargar la siguiente si no hemos terminado
          this.paginaActual++;
          this.cargarProductosPaginados(totalRegistros); // Recursivamente llama hasta que obtengamos todos los registros
        }, error => {
          console.log(error);
          this.clientes = []
          this.clientesCopia = []
          this.barraVisible = false;
        });
    } else {
      console.log('Se han cargado todos los clientes.');

      this.clientes = [];  // Inicializamos el array de clientes vacío

      for (let i = 0; i < this.clientesCopia.length; i++) {
        this.clientes.push(...this.clientesCopia[i]);  // Añadimos cada conjunto de clientes al array 'this.clientes'
      }
      this.cargando = false;
      this.barraVisible = false;
      if(this.controlaCambiosEnLosProductos){
        this.versionarProductos();
      }
      //await this.versionamientoService.versionarProductos(this.clientes);
    }

  }


  async versionarProductos() {
    let companiasId = await localStorage.getItem('companiasId');

    // Consultamos los productos que ya están en la base de datos
    let valores: any = await this.serviciUsuario.buscarCambiosEnLosProductos(companiasId);
    let productosGuardados = JSON.parse(valores['_body']);

    if (productosGuardados && productosGuardados.data && productosGuardados.data[0].length === 0) {
      // Si no hay productos guardados en la base de datos, almacenamos todos los registros obtenidos
      await this.versionarProductosInicial(this.clientes);
      console.log('Se guardaron todos los productos por primera vez en la base de datos.');
    } else {
      // Si ya hay productos, verificamos si hay cambios
      this.tienenDiferencias(this.clientes, companiasId)
    }
  }

  onSearch(search: string) {
    this.page = 0;
    this.search = search;
}

nextPage() {
  this.page+= 100;
}
prevPage() {
  if(this.page > 0) {
    this.page-= 100;
  }
}

selectItems(item: any) {
}

actualizarProducto(producto:any=undefined) {
  let copiaProducto = undefined
  let data = []
  if(producto !==undefined) {
    data.push(producto)
      this.registrarHistorial(producto)
  } else {
    data = this.clientes;
  }
  let productosModificados = data.filter(item => item.modificado); // Filtrar solo los que se modificaron
  let total = productosModificados.length;

  if (total === 0) {
    this.mensajero.mensajeMuestroConCerrado('No hay cambios para actualizar.', 'Info', 'warning',true);
    return;
  }

  this.barraVisibleActualizarProductos = true;
  let contador = 0;

  productosModificados.forEach((producto, index) => {
    let productoData: any = {};
    this.progreso = 0
    this.cd.detectChanges();
    if (producto.tipoProducto === 'P') {
      productoData = {
        existenciasActuales: Number(producto.existenciasActuales),
        existenciasMinimas: Number(producto.existenciasMinimas),
        valorVenta: Number(producto.valorVenta),
        costo: Number(producto.costo),
        productosId: Number(producto.productosId),
        nombreProducto: producto.nombreCompleto,
        queHago: "A",
        nombreTabla: "productos",
        name: "dataDynamicCrud"
      };
    } else {
      productoData = {
        existenciasActuales: Number(producto.existenciasActuales),
        existenciasMinimas: Number(producto.existenciasMinimas),
        valorVenta: Number(producto.valorVenta),
        valorCosto: Number(producto.costo),
        productosElaboradosId: Number(producto.productosId),
        nombreProductoElaborado: producto.nombreCompleto,
        queHago: "A",
        nombreTabla: "productosElaborados",
        name: "dataDynamicCrud"
      };
    }
    let productoActual = ''
    this.barraVisibleActualizarProductos = true
    productoActual = producto.nombreCompleto;
    this.servicio.actualizarProducto(productoData).subscribe(() => {
      contador++;
      this.progreso = Math.round((contador / total) * 100);
      // Mostrar nombre del producto en el spinner
      this.cd.detectChanges();
      if (contador === total) {
        this.barraVisibleActualizarProductos = false;
        this.cd.detectChanges();
        this.mensajero.mensajeMuestroConCerrado('Registros actualizados con éxito.', 'Success!', 'success',true);
   }
    }, (error) => {
      console.log(error);
      this.barraVisibleActualizarProductos = false;
      this.cd.detectChanges();
    });


  });
}



  marcarModificado(producto: any) {
    producto.modificado = true; // Marca el producto como modificado
  }

  atras(){

    this.navCtrl.setRoot('HomePage');
  }

}


class ProductoHistorial {
  public nombreCompleto: string;
  public existenciasActuales: number;
  public existenciasMinimas: number;
  public valorVenta: number;
  public costo: number;
  public fecha: string;  // Fecha del cambio
  public cambios: any;   // Diferencias entre el estado anterior y el actual
}



// WEBPACK FOOTER //
// ./src/pages/inventario/inventario.ts